const Dashboard = () => {

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const handleClick = () => {
        window.location.href = `${BASE_URL}/add`;
    }

    return (
        <div className="container">
            <button onClick={handleClick} className="contact-btn content-2 button-fill">
                Add Project
            </button>
        </div>
    );
}

export default Dashboard;